/**
 * Workforce BFF (backend-for-frontend) auth flag, resolved at RUNTIME.
 *
 * When enabled, the SPA delegates the OAuth2 flow to the actions-api BFF
 * (`/api/rest/data/v1/auth/*`), which holds the refresh token in httpOnly cookies. This
 * restores the session reliably on browser refresh (no third-party-cookie iframe).
 *
 * Resolved the same way as the demo-login flag (see demoLogin.ts): the web image
 * is promoted unchanged across environments, so the value is emitted into
 * index.html as a `%VITE_AUTH_BFF_ENABLED%` placeholder and substituted per
 * environment (Vite HTML env replacement in dev; nginx sub_filter in test/stage/
 * prod — see deploy-aks/charts/20-web-app).
 *
 * This is a non-secret boolean feature toggle; no credentials are exposed.
 */
const resolveAuthBffEnabled = (): boolean => {
  if (typeof document === 'undefined') return false;
  const content = document.querySelector('meta[name="equip-auth-bff"]')?.getAttribute('content');
  return content === 'true';
};

export const AUTH_BFF_ENABLED = resolveAuthBffEnabled();
